
let realTimeData = [];
let operationType = [{
  key: 'add',
  value: '新增'
}, {
  key: 'edit',
  value: '修改'
}, {
  key: 'view',
  value: '查看'
}]

let accountType = [{
  value: 1,
  label: '收运单位'
}, {
  value: 2,
  label: '生产单位'
}, {
  value: 3,
  label: '作业人员'
}]

export {
  realTimeData, //实时数据
  operationType,//表单操作类型
  accountType,//账号类型
}



// WEBPACK FOOTER //
// ./src/config/config.js